const PUNYCODE_PREFIX = "xn--";
const URL_SHORTENERS = [
  "bit.ly",
  "tinyurl.com",
  "t.co",
  "ow.ly",
  "goo.gl",
  "buff.ly",
  "rebrand.ly",
  "is.gd",
  "s.id",
  "cutt.ly"
];

export function extractHostname(url: string): string | null {
  try {
    const parsed = new URL(url);
    return parsed.hostname.toLowerCase();
  } catch {
    return null;
  }
}

export function getDomainFlags(domain: string): string[] {
  const flags: string[] = [];
  if (domain.startsWith(PUNYCODE_PREFIX)) {
    flags.push("punycode domain");
  }
  if (/\d+\.\d+\.\d+\.\d+/.test(domain)) {
    flags.push("ip-address-domain");
  }
  if (domain.split(".").length > 4) {
    flags.push("many-subdomains");
  }
  if (domain.length > 40) {
    flags.push("very-long-domain");
  }
  return flags;
}

export function looksLikeShortener(domain: string): boolean {
  return URL_SHORTENERS.includes(domain);
}

export function detectHomoglyph(domain: string): boolean {
  return /[а-яА-ЯёЁіІїЇ]/.test(domain) || /[^\u0020-\u007E]/.test(domain);
}

export function extractETldPlusOne(domain: string): string {
  const parts = domain.split(".");
  if (parts.length <= 2) return domain;
  return parts.slice(parts.length - 2).join(".");
}
